import Icon from '@/components/ui/AppIcon';

interface CertificationBadgeProps {
  icon: string;
  title: string;
  description: string;
}

const CertificationBadge = ({ icon, title, description }: CertificationBadgeProps) => {
  return (
    <div className="flex items-start gap-4 bg-card rounded-lg p-5 border border-border transition-smooth hover:shadow-elevation-sm">
      <div className="flex-shrink-0 w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center">
        <Icon 
          name={icon as any}
          size={24}
          variant="outline"
          className="text-accent"
        />
      </div>
      <div>
        <h4 className="font-body text-base font-semibold text-foreground mb-1">
          {title}
        </h4>
        <p className="caption text-muted-foreground">
          {description}
        </p>
      </div>
    </div>
  );
};

export default CertificationBadge;